<template>
  <div class="pt-5 pl-md-5 pb-10" style="max-width: 1000px">
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <v-container v-if="!loading" fluid>
      <div v-if="!list.length" class="text-center">
        <v-alert border="left" colored-border color="light-blue" elevation="1"
          >No bookings found.<br />
        </v-alert>
      </div>
      <div v-if="list.length">
        <h1 class="text-h5 mb-5">{{ $t("Bookings") }}</h1>
        <v-row
          class="elevation-1 mb-5 white"
          v-for="item in list"
          :key="item._id"
        >
          <v-col md="3" cols="12">
            <v-skeleton-loader
              v-if="!item.property_id.pictures.length"
              class="mx-auto"
              type="image"
              height="180"
            ></v-skeleton-loader>
            <v-carousel
              show-arrows-on-hover
              hide-delimiters
              class
              height="180"
              v-if="item.property_id.pictures.length"
            >
              <v-carousel-item
                v-for="(items, i) in item.property_id.pictures"
                :key="i"
                :src="
                  $store.state.baseUrl +
                    'listing/thumb320x240-' +
                    items.file_name
                "
              ></v-carousel-item>
            </v-carousel>
          </v-col>
          <v-col md="auto" cols="12">
            <div class="pb-2">
              <v-chip small class="ma-2" color="green" text-color="white">
                {{ $t(item.booking_status) }}
              </v-chip>
              <v-chip small class="ma-2" color="yellow">
                {{ $t("Checkin") }} :
                {{ formatDate(item.booking_details.dates[0] + "T00:00") }}
                {{ item.booking_details.check_in_time }}
              </v-chip>
              <v-chip small class="ma-2" color="yellow">
                {{ $t("Checkout") }} :
                {{ formatDate(item.booking_details.dates[1] + "T00:00") }}
                {{ item.booking_details.check_out_time }}
              </v-chip>
            </div>
            <div class="text-h6">
              {{ item.property_id.name }}
            </div>
            <div class="pt-2">
              <span class="subtitle-2 grey--text">{{ $t("Total") }} : </span>
              <span
                class="text-h6 light-blue--text text--darken-4 font-weight-bold"
                >{{ calculateTotalAmount(item.payments) }}</span
              >
            </div>
            <div class="pt-2">
              <v-btn
                class="mr-2"
                color="light-blue"
                :to="{
                  name: 'ViewBooking',
                  params: { id: item._id }
                }"
                dark
                >{{ $t("ViewBooking") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import timeoutMixin from "@/mixins/timeoutMixin.js";
import priceMixin from "@/mixins/priceMixin.js";
import BookingService from "@/services/BookingService";
import { format } from "date-fns";

export default {
  name: "BookingsListComponent",
  mixins: [timeoutMixin, priceMixin],
  data() {
    return {
      format,
      loading: true,
      list: [],
      error: null
    };
  },
  filters: {},
  created: function() {
    BookingService.getBooking({})
      .then(result => {
        this.list = result.data;
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    formatDate(val) {
      return this.format(new Date(val), "MM/dd/yyyy");
    }
  }
};
</script>

<style></style>
